import React, { FC } from 'react';
import { HowBlockItemType } from 'types/components';
import { Content, Description, Image } from './styled';

export const HowBlockItem: FC<HowBlockItemType & { showBorder: boolean }> = ({
    image,
    description,
    showBorder,
}) => (
    <Content showBorder={showBorder}>
        <Image image={image} />
        <Description variant={'p4'}>{description}</Description>
    </Content>
);
